export default "__VITE_ASSET__rRiKnANr__"